import { CustomFile } from '../models/shared/custom-file';
import { ColorUtils } from './color-utils';
import { MediaType } from '../models/enum/dto/media-type.enum';
import { AttachmentType } from '../models/enum/dto/attachment-type';

export class FileUtils {
  static getPngImageFromHex(hex: string, canvas: HTMLCanvasElement): CustomFile {
    hex = ColorUtils.validateHexColor(hex);
    const ctx = canvas.getContext('2d');
    canvas.width = 500;
    canvas.height = 500;
    if (!!ctx) {
      ctx.fillStyle = hex;
      ctx.fillRect(0, 0, 500, 500);
    }
    const encodedData = 'data:asset/png;base64,' + canvas.toDataURL('asset/png', '').substring(22);
    // Init File for color
    const file = new CustomFile();
    file.name = `${hex}.png`.toLowerCase();
    file.type = MediaType.PNG;
    file.url = encodedData;
    return file;
  }

  static getFileSizeString(sizeInBytes: number): string {
    const sizeInKb = sizeInBytes / 1024;
    const sizeInMb = sizeInKb / 1024;

    if (sizeInMb >= 1) {
      return `${sizeInMb.toFixed(2)} MB`;
    } else {
      return `${sizeInKb.toFixed(2)} KB`;
    }
  }

  static getAttachmentTypeFromFile(file: File): AttachmentType {
    const imageTypes = ['image/png', 'image/jpeg'];
    const pdfTypes = ['application/pdf'];

    const mimeType = file.type.toLowerCase();
    if (imageTypes.includes(mimeType)) {
      return AttachmentType.Image;
    } else if (pdfTypes.includes(mimeType)) {
      return AttachmentType.PDF;
    } else {
      return AttachmentType.Doc;
    }
  }
}
